export default {
  'depositAccountDetails.workflow.view': 'Deposit Account Details',
  'depositAccountDetails.depositAccount': 'Deposit Account',
  'depositAccountDetails.balance': 'Balances as of',
  'depositAccountDetails.transactionFor': 'Transaction for',
  'deposit.accountName': 'Account Name',
  'deposit.accountNumber': 'Account Number',
  'deposit.currencyCode': 'Currency Code',
  'deposit.ledgerBal': 'Opening Ledger',
  'deposit.collectedBal': 'Current Ledger',
  'deposit.currentBal': 'Current Available',
  'deposit.closingBal': 'Closing Ledger',
  'deposit.closingAvailable': 'Closing Available',
  'deposit.availableBal': 'Current Available (CRS Suppressed)',
  'deposit.totalFundsAvailable': 'Adjusted Balance',
  'deposit.asOfDate': 'Balance As Of'
};
